import { Component, inject, OnInit, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterOutlet, RouterLink } from "@angular/router";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BriTeammateAuthorizationService } from "@davita/bridge-utility-library/authorization";
import { Subscription } from "rxjs";
import { environment } from "../../environments/environment";
import { AppSideNavComponent } from "../components/app-side-nav/app-side-nav.component";

@Component({
  selector: "app-layout",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    AppSideNavComponent,
  ],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.css",
})
export class LayoutComponent implements OnInit, OnDestroy {
  isAuthEnabled = !!environment.apiBaseUrl;
  isLoggedIn = false;
  userName = "";
  private userSub?: Subscription;

  private router = inject(Router);
  private teammateAuth = this.isAuthEnabled
    ? inject(BriTeammateAuthorizationService)
    : null;

  ngOnInit() {
    if (this.teammateAuth) {
      this.userSub = this.teammateAuth.user$.subscribe((user: any) => {
        this.isLoggedIn = !!user;
        this.userName = user?.oim_details?.userLogin || "";
      });
    }
  }

  ngOnDestroy() {
    this.userSub?.unsubscribe();
  }

  login() {
    this.router.navigate(["/teammate-login"]);
  }

  logout() {
    if (this.teammateAuth) {
      this.teammateAuth.logout();
    }
  }
}
